// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page layout adjustments when global header is present */
.has-global-header .page-layout {
  height: 100vh !important;
  min-height: 100vh !important;
  grid-template-columns: auto 1fr !important;
  grid-template-rows: auto minmax(0, 1fr) !important;
  overflow: hidden;
}

/* Collapse sidebar column on mobile */
@media (max-width: 767px) {
  .has-global-header .page-layout {
    grid-template-columns: 0 1fr !important;
  }
}

/* Enable scrolling within main content area */
.has-global-header #content {
  overflow: auto;
  min-height: 0;
}

.has-global-header #global-header-container {
  display: block !important;
}
`, "",{"version":3,"sources":["webpack://./src/global-header.css"],"names":[],"mappings":"AAAA,0DAA0D;AAC1D;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,0CAA0C;EAC1C,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Page layout adjustments when global header is present */\n.has-global-header .page-layout {\n  height: 100vh !important;\n  min-height: 100vh !important;\n  grid-template-columns: auto 1fr !important;\n  grid-template-rows: auto minmax(0, 1fr) !important;\n  overflow: hidden;\n}\n\n/* Collapse sidebar column on mobile */\n@media (max-width: 767px) {\n  .has-global-header .page-layout {\n    grid-template-columns: 0 1fr !important;\n  }\n}\n\n/* Enable scrolling within main content area */\n.has-global-header #content {\n  overflow: auto;\n  min-height: 0;\n}\n\n.has-global-header #global-header-container {\n  display: block !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
